<template>
  <main class="result-page" @click.self="router.push('/')">
    <div v-if="isPending" class="result-card result-card--loading">
      <p>Looking up {{ code }}…</p>
    </div>
    <div v-else class="result-card" :class="found ? 'result-card--found' : 'result-card--not-found'">
      <div class="result-icon" aria-hidden="true">{{ found ? '🚨🚔' : '🏁💨' }}</div>
      <h2>{{ found ? 'Bolisbil!' : 'All clear' }}</h2>
      <p class="result-code">{{ code }}</p>
      <p v-if="found" class="result-detail">
        This is a known bolisbil. Exercise caution.
      </p>
      <p v-else class="result-detail">
        No record found for this combination.
      </p>
      <button class="btn btn-primary" @click="router.push('/')">
        OK
      </button>
    </div>
  </main>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCodeLookup } from '../queries/useCodeLookup.ts';

const route = useRoute();
const router = useRouter();

const code = computed(() => (route.params.code as string).toUpperCase());
const { data, isPending } = useCodeLookup(code);
const found = computed(() => !!data.value);
</script>

<style scoped>
.result-page {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.result-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  max-width: 360px;
  width: 100%;
  text-align: center;
  border-top: 5px solid transparent;
}

.result-card--found {
  border-top-color: #dc2626;
}

.result-card--not-found {
  border-top-color: #16a34a;
}

.result-icon {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}

.result-card h2 {
  margin: 0 0 0.5rem;
  font-size: 1.5rem;
}

.result-code {
  font-family: 'Courier New', monospace;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.25rem;
  margin: 0.5rem 0;
  color: #111;
}

.result-detail {
  color: #555;
  margin: 0 0 1.5rem;
}

.btn {
  width: 100%;
  padding: 0.875rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  min-height: 48px;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
}

@media (prefers-color-scheme: dark) {
  .result-card {
    background: #1f2937;
    color: #f9fafb;
  }

  .result-code {
    color: #f9fafb;
  }

  .result-detail {
    color: #9ca3af;
  }
}
</style>
